import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { VistaMuestreadorContainerComponent } from './vista-muestreador/components/vista-muestreador-container/vista-muestreador-container.component';
import { VistaTecnicoResponsableContainerComponent } from './vista-tecnico-responsable/components/vista-tecnico-responsable-container/vista-tecnico-responsable-container.component';
import { VistaIntegranteContainerComponent } from '../vista-integrante/components/vista-vinculo-container/vista-integrante-container.component';
import { VistaVinculosContainerComponent } from '../vista-vinculos/components/vista-vinculos-container/vista-vinculos-container.component';
import { VistaNuevoVinculoContainerComponent } from '../vista-nuevo-vinculo/components/vista-nuevo-vinculo-container/vista-nuevo-vinculo-container.component';

const routes: Routes = [  
  {
    path: 'vista-muestreador',
    component: VistaMuestreadorContainerComponent,
    data: { title: 'rpe.route.vista-muestreador' }    
  },
  {
    path: 'vista-tecnico-responsable',
    component: VistaTecnicoResponsableContainerComponent,
    data: { title: 'rpe.route.vista-tecnico-responsable' }
  },
  {
    path: 'vista-integrante',
    component: VistaIntegranteContainerComponent
  },
  {
    path: 'vinculos-laborales',
    component: VistaVinculosContainerComponent
  },
  {
    path: 'nuevo-vinculo-laboral',
    component: VistaNuevoVinculoContainerComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RolesRoutingModule {}
